export const GREETING_WINDOW_HOURS = 12

const LAST_LOGIN_KEY_PREFIX = 'hms_last_login_'
const GREETING_SESSION_KEY = 'hms_greeting'

export type LoginGreetingState = {
  userId: string
  returning: boolean
}

export function getTimeOfDayGreeting(date = new Date()) {
  const hour = date.getHours()
  if (hour < 12) return 'Good morning'
  if (hour < 17) return 'Good afternoon'
  return 'Good evening'
}

export function getFirstName(fullName?: string) {
  return fullName?.trim().split(/\s+/)[0] || ''
}

export function readStoredLastLogin(userId: string) {
  try {
    return localStorage.getItem(`${LAST_LOGIN_KEY_PREFIX}${userId}`)
  } catch {
    return null
  }
}

export function recordLoginGreeting(
  userId: string,
  previousLoginAt: string | null,
  now = new Date(),
) {
  const previous = previousLoginAt ? new Date(previousLoginAt) : null
  const elapsed =
    previous && !Number.isNaN(previous.getTime())
      ? now.getTime() - previous.getTime()
      : null
  const returning =
    elapsed !== null &&
    elapsed >= 0 &&
    elapsed <= GREETING_WINDOW_HOURS * 60 * 60 * 1000
  const state: LoginGreetingState = {
    userId,
    returning,
  }
  try {
    localStorage.setItem(
      `${LAST_LOGIN_KEY_PREFIX}${userId}`,
      now.toISOString(),
    )
    sessionStorage.setItem(GREETING_SESSION_KEY, JSON.stringify(state))
  } catch {
    // Storage unavailable — the time-of-day greeting is used instead.
  }
  return state
}

export function readLoginGreeting(userId: string): LoginGreetingState | null {
  try {
    const raw = sessionStorage.getItem(GREETING_SESSION_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as LoginGreetingState
    return parsed.userId === userId ? parsed : null
  } catch {
    return null
  }
}

export function clearLoginGreeting() {
  try {
    sessionStorage.removeItem(GREETING_SESSION_KEY)
  } catch {
    // ignore
  }
}

export function buildGreeting(
  fullName: string | undefined,
  returning: boolean,
  date = new Date(),
) {
  const firstName = getFirstName(fullName)
  if (returning && firstName) return `Welcome back, ${firstName}`
  const timeGreeting = getTimeOfDayGreeting(date)
  return firstName ? `${timeGreeting}, ${firstName}` : timeGreeting
}
